<script>
  export let next;
</script>

<div>
  <h1>Step 2</h1>
  <h2>TBD</h2>
  <a href="#" on:click="{next}">Start App</a>
</div>

<style>
  div {
    text-align: center;
  }
</style>
